import React, { useState ,useEffect, useRef } from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import PendingAdItem from '../../Components/PendingAdItem/PendingAdItem'
import Slider from 'react-slick'
import { setting } from '../../Common/setting'
import userApi from '../../Common/Api/UserApi'

import './EditBooks.css'

const EditBook = () => {

  const {id} = useParams();
  const bookId = id.substring(1);

  const { books,categories } = useSelector((state)=>{
    return (state.Books);
  })

  const[book,setBook] = useState({images:[],authors:[]});

  const [finalCategories,setFinalCategories] = useState([]);    // those categories that are chosen by admin (should have initial value of categories which are already on book)
  const [givenCategories,setGivenCategories] = useState([]);    // All the categories on site -(minus) finalCategories

  const fetchBookDetails = ()=>{
    let found = books.find(x => x._id === bookId)
    setBook(found);

    
      setAuthors(found.authors);
      setPrice(found.fixedPrice);
      setTitle(found.title)

    console.log("bigger array : ",categories);
    console.log("shorter array : ",found.categories);


    const temp1  = categories.filter(o=> !found.categories.some(i=> i._id === o._id));

    const temp2=[];
    temp1.map((element)=>{
        temp2.push({
            _id:element._id,
            name:element.name
        })
    })
    console.log("given categories : ",temp2);
    setGivenCategories(temp2);
    setFinalCategories(found.categories)
    
    
  }

  const addCategory = (element)=>{
    // add to final
    setFinalCategories([...finalCategories,element]);

    // remove from given
    setGivenCategories(givenCategories.filter((ele)=>ele._id!==element._id));

  }
  const removeCategory=(element)=>{
    // remove from final
    setFinalCategories(finalCategories.filter((ele)=>ele._id!==element._id));

    // remove from given
    setGivenCategories([...givenCategories,element]);

  }

    // for authors   
  const [author,setAuthor] = useState('');
  const [addAuthor,setAddAuthor]=useState(false);
  const [authors,setAuthors] = useState([])     // final array of authors

  const removeAuthor = (element)=>{
    setAuthors(authors.filter((e)=>e!==element));
  }

  //   for price
  const [price,setPrice] = useState('')
  const [changePrice,setChangePrice]=useState(false);
  //   for title
  const [title,setTitle] = useState('')
  const [changeTitle,setChangeTitle]=useState(false);

  const navigate = useNavigate();
  const editBook=async()=>{

    console.log("book id : ",bookId)
    const data = await userApi.post(`/admin/ads/${bookId}/edit`,{
      authors:authors,
      categories:finalCategories,
      title:title,
      fixedPrice:price
    });

    console.log("data from route : ",data);

    alert("Book Successfully Editted !");
    navigate(-1);

  }
  console.log(book)

  useEffect(() => {
      
      fetchBookDetails();
      
      
    }, [])
    // console.log(book)

  return (
    <div>
        <Navbar/>
        <div className='viewAd-container'>
    
          <div className='req-container'>
              
              <h2 style={{color:"rgb(57, 57, 57)",cursor:"pointer"}} onClick={()=>setChangeTitle(true)}>Title - {title} <i className="fa-regular fa-pen-to-square"></i> </h2>
              {(book.images.length <=3)? 
                  <div className='row' >
                      {
                      book.images.map((element) => {
                        
                          return (

                          <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                              <PendingAdItem displayInfo = "false" img={element} />
                          </div>
                          
                          )})
                      }
                  </div>:

                  <Slider {...setting}>
                  {
                    book.images.map((element) => {
                      
                      return (
                          <PendingAdItem displayInfo = "false" img={element} />
                      )})
                  }
                  </Slider>
              }
              
              <div className='viewAd-main'>
                  <div className='view-ad-details' style={{width:"100%"}}>

                      <div className='ad-details-row'>

                          <div className='ad-detail'> 
                            <span  style={{cursor:"pointer"}} onClick={()=>setAddAuthor(true)}>
                                <b> Authors  <i className="fa-regular fa-pen-to-square"></i> - </b>
                            </span> 
                            { authors.map((element)=>{
                              return (
                                <div className='select-categories-container view-book-category'>
                                    <span>{element}</span>
    <i className="fa-solid fa-square-xmark view-book-category-cross" onClick={()=>removeAuthor(element)}></i> 
                                </div>
                                    );
                                }) 
                            }
                          </div>

                          <div className='ad-detail'> 
                            <span  style={{cursor:"pointer"}} onClick={()=>setChangePrice(true)}>
                                <b>Price  <i className="fa-regular fa-pen-to-square"></i> -  </b> {price}
                            </span>  
                          </div>

                          <div className='ad-detail'>
                            <span  style={{cursor:"pointer"}}>
                                <b>Book Edition </b> - {book.edition}
                            </span>
                          </div>

                      </div>
                      <div className='ad-details-row'>
                          <div className='ad-detail'> <b>Damage on Book -</b>  {book.damage}</div>
                          <div className='ad-detail'> <b> Total Pages -</b> {book.totalPages}</div>
                          <div className='ad-detail'> <b>Number of Marked Pages -</b>  {book.markedPages}</div>
                      </div>

                  </div>
              </div>

              <h4 style={{marginTop:"3%"}}>Categories of this book : </h4> 
              <div className='view-ad-buttons-container' style={{backgroundColor:"pink"}}>
              {
                  finalCategories.map((element)=>{
                      return (
                      <div className='select-categories-container view-book-category' >
                          
                          <label>{element.name}</label>
                          <i className="fa-solid fa-square-xmark view-book-category-cross" onClick={()=>removeCategory(element)}></i> 
                      </div>
                      )
                  })
              }    
              </div>

              <h4 style={{marginTop:"3%"}}>Categories on Site : </h4>
              <div className='view-ad-buttons-container' style={{backgroundColor:"pink"}}>
              {
                  givenCategories.map((element)=>{
                      return (
                      <div className='select-categories-container view-book-category' >
                          
                          <label>{element.name}</label>
                          <i className="fa-solid fa-plus view-book-category-cross" style={{fontWeight:"600"}} onClick={()=>addCategory(element)}></i>
                      </div>
                      )
                  })
              }    
              </div>

          <button className='send-final-btn' onClick={editBook} >Edit Book</button>
          </div>



          {addAuthor && <div className='Modal'>
                <div className='modal-container' style={{width:"30vw"}}>
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setAddAuthor(false)}></i>
                    <h4>Enter the Author</h4>
                    <input type="text" value={author} onChange={(e)=>{e.preventDefault(); setAuthor(e.target.value)}}/>
                    <button onClick={()=>{setAuthors([...authors,author]); setAuthor(''); setAddAuthor(false)}}>Add Author</button>
                </div>
            </div>}
          {changePrice && <div className='Modal'>
                <div className='modal-container' style={{width:"30vw"}}>
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setChangePrice(false)}></i>
                    <h4>Enter the Price</h4>
                    <input type="text" value={price} onChange={(e)=>{e.preventDefault(); setPrice(e.target.value)}}/>
                    <button onClick={()=>{setChangePrice(false)}}>Change Price</button>
                </div>
            </div>}
          {changeTitle && <div className='Modal'>
                <div className='modal-container' style={{width:"30vw"}}>
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setChangeTitle(false)}></i>
                    <h4>Change Title of Book</h4>
                    <input type="text" value={title} onChange={(e)=>{e.preventDefault(); setTitle(e.target.value)}}/>
                    <button onClick={()=>{setChangeTitle(false)}}>Change Ttile</button>
                </div>
            </div>}
          
      </div>
        <Footer/>
    </div>
  )
}

export default EditBook